import { ursaColors } from "@smartsheet/design-tokens";
import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";

interface SignalBarsIconProps extends SVGProps<SVGSVGElement> {
    value: number;
    emptyFillColor?: string;
    fillColor?: string;
}

const SvgComponent = (
    { fillColor = ursaColors.azure400, emptyFillColor = ursaColors.neutral200, ...props }: SignalBarsIconProps,
    ref: Ref<SVGSVGElement>
) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.2999 2.80005C16.797 2.80005 17.1999 3.20299 17.1999 3.70005V16.3C17.1999 16.7971 16.797 17.2 16.2999 17.2C15.8028 17.2 15.3999 16.7971 15.3999 16.3V3.70005C15.3999 3.20299 15.8028 2.80005 16.2999 2.80005Z"
            fill={props.value >= 4 ? fillColor : emptyFillColor}
        />
        <path
            d="M11.9688 6.03076C12.4659 6.03076 12.8688 6.43371 12.8688 6.93076V16.3C12.8688 16.797 12.4659 17.2 11.9688 17.2C11.4718 17.2 11.0688 16.797 11.0688 16.3V6.93076C11.0688 6.43371 11.4718 6.03076 11.9688 6.03076Z"
            fill={props.value >= 3 ? fillColor : emptyFillColor}
        />
        <path
            d="M8.03135 9.58472C8.5284 9.58472 8.93135 9.98766 8.93135 10.4847V16.3001C8.93135 16.7972 8.5284 17.2001 8.03135 17.2001C7.53429 17.2001 7.13135 16.7972 7.13135 16.3001V10.4847C7.13135 9.98766 7.53429 9.58472 8.03135 9.58472Z"
            fill={props.value >= 2 ? fillColor : emptyFillColor}
        />
        <path
            d="M3.70005 12.1692C4.19711 12.1692 4.60005 12.5721 4.60005 13.0692V16.3C4.60005 16.797 4.19711 17.2 3.70005 17.2C3.20299 17.2 2.80005 16.797 2.80005 16.3V13.0692C2.80005 12.5721 3.20299 12.1692 3.70005 12.1692Z"
            fill={props.value >= 1 ? fillColor : emptyFillColor}
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
